const FormLabel = ({ children, htmlFor }) => {
  return (
    <label htmlFor={htmlFor} className="block text-sm/6 font-medium text-zinc-900 mb-2">
      {children}
    </label>
  );
};

export default FormLabel;